module.exports = __webpack_public_path__ + "static/media/alchemy.78ea263f.jpeg";